module.exports = __webpack_public_path__ + "img/ihch.54916a6d.png";